import React from 'react';
import {
  AppBar,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Slide,
  Toolbar,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

// Recipe oficial do MUI para diálogo de tela cheia: desliza como se fosse
// abrir uma página, em vez de simplesmente aparecer.
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

/**
 * Diálogo de formulário do mobile (filtros, criar/editar lista…): tela cheia
 * com slide no celular e card arredondado no desktop, cabeçalho com voltar
 * (fecha) e título, e rodapé (`actions`) com padding padrão. O layout dos
 * botões do rodapé fica com quem usa. `headerActions`: botões de ícone à
 * direita do título (ex.: excluir, editar).
 */
const FullScreenDialog = ({
  open,
  onClose,
  title,
  actions,
  headerActions,
  maxWidth = 'md',
  children,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={!isDesktop}
      fullWidth={isDesktop}
      maxWidth={isDesktop ? maxWidth : false}
      slots={isDesktop ? undefined : { transition: Transition }}
      slotProps={isDesktop ? { paper: { sx: { maxHeight: '85vh', borderRadius: 3 } } } : undefined}
    >
      {/* Transparente: herda o fundo do diálogo, inclusive o clareamento por elevação
          do modo escuro. `color="default"` usaria o cinza padrão do MUI (fora do tema). */}
      <AppBar
        position="relative"
        elevation={0}
        // Sem isso, no escuro o MUI força o fundo da AppBar por cima do `sx`.
        enableColorOnDark
        sx={{ bgcolor: 'transparent', color: 'text.primary', borderBottom: 1, borderColor: 'divider' }}
      >
        <Toolbar>
          <IconButton edge="start" onClick={onClose} size="small" aria-label={t('back')}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" noWrap sx={{ ml: 1, flex: 1, minWidth: 0 }}>
            {title}
          </Typography>
          {headerActions}
        </Toolbar>
      </AppBar>

      <DialogContent sx={{ px: 2, py: 3 }}>{children}</DialogContent>

      {actions && <DialogActions sx={{ p: 2 }}>{actions}</DialogActions>}
    </Dialog>
  );
};

export default FullScreenDialog;
